import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Flex, Form, Input, Row, Button, DatePicker, Select } from "antd";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import { getSearch, getFormats } from "./searchSlice";
import { buildQueryString, debounce } from "../../utils/helpers";
import { IconSearch } from "../../components/IconSearch/IconSearch";
import { SearchSelect } from "../../components/SearchSelect/SearchSelect";

import css from "../Dashboard/Dashboard.module.css";
import dayjs from "dayjs";
//import formats from '../../constants/formats';

const { RangePicker } = DatePicker;

export const SearchBox = ({onApply, initialValues, onReset}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const selectRef = React.useRef(null);

  const [search, setSearch] = React.useState([]);
  const [searchValues, setSearchValues] = React.useState([]);
  const [format, setFormat] = React.useState([]);
  const [range, setRange] = React.useState({start: null, end: null});
  
  useEffect(() => {
	if (initialValues) {
      const { searchValues = [], format = [], range = { start: null, end: null } } = initialValues;
			setSearch(searchValues.map((s) => s.value));
			setSearchValues(searchValues);
			setFormat(format);
			setRange(range);

      form.setFieldsValue({
        search: searchValues.map((s) => s.value),
        range: range.start && range.end ? [dayjs(range.start), dayjs(range.end)] : null,
        format,
      });
    }
  }, [initialValues]);
  
  const reset = () => {
	  form.resetFields();
  
	  const emptySearch = {
		  search: [],
		  format: [],
		  range: { start: null, end: null },
	  };
  
	  setSearch([]);
	  setSearchValues([]);
	  setFormat([]);
	  setRange(emptySearch.range);
	  sessionStorage.removeItem("dashboardSearch");
	  sessionStorage.removeItem("dashboardBackToSearch");
  
	  //onApply(emptySearch);
	  onReset();
  };

  useEffect(() => {
	dispatch(getFormats()); 
  }, []);
  
  const { formats, getFormatsInProgress } =
	useSelector((state) => state?.search) || {};
  
  const isFilterSelected = () => {
	  if(search.length == 0 && format.length == 0 && range.start == null && search.end == null)
	  	return false;
	  return true;
  }
  
  const filterAndAdd = (results) => {
	 const addEntities = ['catalog', 'UPC']; 
	 let newEntitiesAdded = false;
	 let filteredResults = [], newSearch = [...search], newSearchValues = [...searchValues];
	 for(let row of results) {
		if(addEntities.includes(row.entity)) {
			if(!newSearch.includes(row.value)) {
				newEntitiesAdded = true;
				newSearch.push(row.value);
				newSearchValues.push(row);
			}
		}
		else {
			filteredResults.push(row);
		}
	 } 
	 if(newEntitiesAdded) {
		setSearch(newSearch);
		setSearchValues(newSearchValues); 
		form.setFieldsValue({
			search: newSearch
		})
		if (selectRef.current) {
			selectRef.current.blur();
		}
	 }
	 return filteredResults;
  }
  
  const getFormattedSearch = async(query) => {
	  const values = await dispatch(getSearch({query}));
	  const fullResults = Array.isArray(values.payload) ? values.payload.map(result=>({
		  label: `${result.name} (${result.entity})`,
		  value: `${result.name} (${result.entity})`,
		  term: result.name,
		  entity: result.entity
	  })) : [];  
	  return filterAndAdd(fullResults);
	}
	
  const handleDateChange = (dates) => {
  	if(dates) {
  		const [start, end] = dates || [];
  		setRange({start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD')});
  	} 
		else {
			setRange({start: null, end: null});
		}
  };
  
  const initialDates = [range.start, range.end];
  //const formatOptions = formats.map(f=>{f.value = String(f.value); return f;}).sort((a, b) => b.label < a.label);

  return (
	<Flex className={""} vertical>
	  <Form
		name="searchForm"
		style={{ marginTop: 10, marginBottom: 0 }}
		initialValues={{ remember: true }}
		autoComplete="off"
		form={form}
	  >
		<Row gutter={16} className={css.searchFormContainer}>
		  <Col xs={24} md={24} lg={12} xxl={10} className={css.formItem}>
				<Form.Item name="search" label="Search:" className={css.searchSelect}>
					<SearchSelect
						
						mode="multiple"
						value={search}
						placeholder="Select labels, artists, product name, project number and UPC"
						fetchOptions={getFormattedSearch}
						onChange={(newValue, selected) => {
							setSearch(newValue);
							setSearchValues(selected);
						}}
						style={{
							width: '100%',
						}}
						//className="select-search"
					/>
				</Form.Item>
		  </Col>
		  <Col xs={24} md={24} lg={12} xxl={6} className={css.formItem}>
				<label htmlFor="range">Release Date:</label>
		  	<Form.Item name="range">
		  		<RangePicker
			  		size={"large"}
			  		value={initialDates}
			  		onChange={handleDateChange}
		  		/>
		  	</Form.Item>
		  </Col>
		  <Col xs={24} md={24} lg={12} xxl={4} className={css.formItem}>
				
				<Form.Item name="format" label="Format:">
					<Select
						mode="multiple"
						allowClear
						options={formats}
						onChange={setFormat}
						placeholder="Formats"
					/>
				</Form.Item>
		  </Col>
		  <Col xs={24} md={24} lg={12} xxl={4} className={css.actionsWrapper}>
				{isFilterSelected() && <Button type="default" htmlType="submit" onClick={()=>reset()}>
					Clear Selection
				</Button>}
				<Button type="primary" htmlType="submit" onClick={()=>onApply({searchValues, format, range})}>
					{isFilterSelected() ? 'Apply' : 'Load All'}
				</Button>

		  </Col>
		</Row>
	  </Form>
	</Flex>
  );
};
